export default __webpack_public_path__ + "static/media/maduro-4Open.6bc80d02.jpg";